import { render, staticRenderFns } from "./new.vue?vue&type=template&id=20d9cc66&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"
import style0 from "./new.vue?vue&type=style&index=0&id=20d9cc66&prod&lang=css"
import style1 from "./new.vue?vue&type=style&index=1&id=20d9cc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d9cc66",
  null
  
)

export default component.exports